module.exports = __webpack_public_path__ + "static/media/ceiling-mid.3452aebb.png";